import { ClaimTransactionOverview } from '../components/transaction-overview/ClaimTransactionOverview'
import { TxOverview } from '../types'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'

export interface ClaimViewProps {
  actionsViewState: ActionsViewState
  txOverview: TxOverview
}

export function ClaimView({ actionsViewState, txOverview }: ClaimViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>Claim rewards</DialogTitle>

      <FormAndOverviewWrapper>
        <ClaimTransactionOverview txOverview={txOverview} />
      </FormAndOverviewWrapper>

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
